import { render, staticRenderFns } from "./processModal.vue?vue&type=template&id=4b91979c&scoped=true"
import script from "./processModal.vue?vue&type=script&lang=js"
export * from "./processModal.vue?vue&type=script&lang=js"
import style0 from "./processModal.vue?vue&type=style&index=0&id=4b91979c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91979c",
  null
  
)

export default component.exports